export const ALUNAR_FUNNEL_VERSION = 'alunar-2026-09-v1' as const;

export function isAlunarFunnelVersion(value: unknown): value is typeof ALUNAR_FUNNEL_VERSION {
  return value === ALUNAR_FUNNEL_VERSION;
}
